import { imageUrl } from '../../utils';
import WithNavbarHeightApplied from '../hoc/WithNavbarHeightApplied';
import Info from './Info';
import SubInfo from './SubInfo';
import RoundInfo from './RoundInfo';

interface CaseStudyHeaderProps {
  pillLabel?: string;
  title: string | React.ReactNode;
  description?: string;
  image?: string;
  altTag?: string;
  containerClass?: string;
  features?: Array<{ icon?: string; label: string }>;
}

const CaseStudyHeader = ({
  pillLabel,
  title,
  description,
  image,
  altTag,
  containerClass,
  features
}: CaseStudyHeaderProps) => {
  const imgSrc = image ? imageUrl(image) : null;

  return (
    <section className={`relative container mx-auto px-4 py-16 sm:py-24 overflow-hidden ${containerClass || ''}`}>
      {/* Gradient background overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_100%_at_top,rgba(245,202,9,0.3),transparent_70%)] z-0"></div>
      
      {/* Background image if provided */}
      {imgSrc && (
        <div
          className="absolute left-0 top-0 w-full opacity-0 breaktwo:opacity-20 h-full z-[-1] bg-no-repeat bg-top text-[0]"
          style={{ backgroundImage: `url(${imgSrc})` }}
          aria-hidden="true"
        >
          {altTag}
        </div>
      )}

      <WithNavbarHeightApplied>
        <div className="relative max-w-4xl mx-auto space-y-8 text-center z-0">
          {/* Pill/Badge - using RoundInfo component */}
          {pillLabel && (
            <RoundInfo containerClasses="breaktwo:mb-4 mb-8 breaktwo:mt-6 mx-auto !bg-gradient-to-br !from-[#FA832E] !to-[#F5CA09]" style={{ color: '#ffffff' }}>
              {pillLabel}
            </RoundInfo>
          )}

          {/* Main heading - using Info component with app's font sizes */}
          <Info 
            className="lg:!text-[42px] md:!text-[36px] !text-[32px]"
            containerClasses="mb-0"
          >
            {typeof title === 'string' ? title : title}
          </Info>

          {/* Description - using SubInfo component */}
          {description && (
            <SubInfo 
              containerClasses="max-w-2xl mx-auto breaktwo:mt-4 mt-8 px-4 md:px-8 lg:px-12" 
              typographyStyles={{ fontFamily: 'var(--fontPrimary)' }}
            >
              {description}
            </SubInfo>
          )}

          {/* Feature badges */}
          {features && features.length > 0 && (
            <div className="flex items-center justify-center gap-6 pt-4 flex-wrap">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-2" style={{ color: '#728F8B' }}>
                  {feature.icon && (
                    <img 
                      src={imageUrl(feature.icon)} 
                      alt={feature.label} 
                      className="w-5 h-5"
                    />
                  )}
                  <span className="text-sm font-medium" style={{ fontFamily: 'var(--fontPrimary)' }}>
                    {feature.label}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </WithNavbarHeightApplied>
    </section>
  );
};

export default CaseStudyHeader;

